module.exports = __webpack_public_path__ + "img/hr-H-T-5-unload-connect-shadow.4bd94f8b.png";